module.exports = {
    API_CHANNEL : 'CIC',
    COMMISSION_PERCENTAGE: 3.90,
    MINIMUM_TO_TRANSFER: 100,
    MAXIMUM_TO_TRANSFER: 6000,
    AMOUNT_MULTIPLE_OF_NUMBER: 100,
    COMMISSION_TABLE_URL: 'https://bancoonline.openbank.es/csopen/StaticBS?blobcol=urldata&blobheader=application%2Fpdf&blobkey=id&blobtable=MungoBlobs&blobwhere=1287274710300&cachecontrol=immediate&ssbinary=true&maxage=3600',
}
